import { Component, Input, OnInit } from '@angular/core';
import { PaymentV2Service } from '../../shared/services';

@Component({
  selector: 'app-qrcode-box',
  templateUrl: './qrcode-box.component.html',
  styleUrls: ['./qrcode-box.component.scss']
})
export class QrcodeBoxComponent implements OnInit {

  @Input() config;
  @Input() code;
  @Input() title = 'Scan this code from your app and make the Payment';
  @Input() icons = 'upi';

  constructor(
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
  }

}
